// @flow
import React from 'react'
import Img from 'gatsby-image'
import { css } from 'glamor'
import type { ContentfulAsset } from 'types'
import Gif from './Gif'

const blur = css({
  '> img[src^="data"]': {
    filter: 'blur(5px)',
    transform: 'scale(1.03)',
  },
})

type Props = {
  image: ContentfulAsset,
}

const GalleryImage = ({
  image: {
    title,
    sizes,
    file: { url = '', contentType = '' },
    fields,
  },
}: Props) =>
  contentType != null && /image/.test(contentType) ? (
    <Img sizes={sizes} alt={title} className={blur} />
  ) : (
    <Gif
      src={url}
      contentType={contentType}
      aspectRatio={
        fields != null && fields.aspectRatio != null ? fields.aspectRatio : 0
      }
    />
  )

export default GalleryImage



// WEBPACK FOOTER //
// ./src/components/GalleryImage.js